import React from "react";
import AffiliateWithdrawals from "../../components/Pages/Affiliates/AffiliateWithdrawals/AffiliateWithdrawals";

const Withdrawals = () => {
  return (
    <div>
      <AffiliateWithdrawals />
    </div>
  );
};

export default Withdrawals;
